/**
 * The only widths admin modals and drawers should use.
 *
 * Modal: confirmations and short forms (sm/md); long forms (lg/xl).
 * Drawer: record details opened from a table row, so the list stays visible.
 */
export const MODAL_WIDTH = {
  sm: 440,
  md: 600,
  lg: 840,
  xl: 1080,
};

export const DRAWER_WIDTH = {
  md: 560,
  lg: 760,
  xl: 960,
};

/** Shared props for form modals: never lose typed input to a stray click. */
export const formModalProps = {
  destroyOnHidden: true,
  maskClosable: false,
  centered: false,
};

/** Standard Table props for admin lists. */
export const tableDefaults = {
  size: 'middle',
  scroll: { x: 'max-content' },
};

export const paginationDefaults = {
  showSizeChanger: true,
  pageSizeOptions: [10, 20, 50, 100],
  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
};
